/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from '@/layouts/components/navbar/navbarSearchAndPinList'
import themeConfig from '@/../themeConfig.js'
import colors from '@/../themeConfig.js'
import { supportState } from '@/utils/student-support-session'


// /////////////////////////////////////////////
//  Variables
// /////////////////////////////////////////////

const userDefaults = {
  uid: 0,          // From Auth
  displayName: 'John Doe', // From Auth
  about: 'Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.',
  photoURL: require('@/assets/images/portrait/small/avatar-s-12.jpg'), // From Auth
  status: 'online',
  userRole: 'admin'
}

// /////////////////////////////////////////////
//  State
// /////////////////////////////////////////////

export const state = {
  status                    : {
    processing              : false,
    error                   : null,
    success                 : null,
    previous                : null
  },
  API_SERVER              : process.env.VUE_APP_API_SERVER,
  AUTH_SERVER             : process.env.VUE_APP_AUTH_SERVER,
  PACKAGE_VERSION         : process.env.VUE_APP_PACKAGE_VERSION,
  currentLocale           : 'th',
  AppActiveUser           : userDefaults,
  bodyOverlay             : false,
  isVerticalNavMenuActive : true,
  mainLayoutType          : themeConfig.mainLayoutType || 'vertical',
  navbarSearchAndPinList,
  reduceButton            : themeConfig.sidebarCollapsed,
  verticalNavMenuWidth    : 'default',
  verticalNavMenuItemsMin : false,
  scrollY                 : 0,
  starredPages            : navbarSearchAndPinList['pages'].data.filter((page) => page.is_bookmarked),
  theme                   : themeConfig.theme || 'light',
  themePrimaryColor       : colors.primary,
  navMenuItems            : [],
  currentUser             : !supportState.mode && localStorage.getItem('currentUser') != null ? JSON.parse(localStorage.getItem('currentUser')) : null,
  token                   : !supportState.mode && localStorage.getItem('token') != null ? localStorage.getItem('token') : null,
  permissions             : [],

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null,
  is_touch_device         : is_touch_device()
}

export default state


function is_touch_device () {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
  const mq = function (query) {
    return window.matchMedia(query).matches
  }

  if (('ontouchstart' in window) || window.DocumentTouch) {
    return true
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
  return mq(query)
}
